// extracted by mini-css-extract-plugin
module.exports = {"hiddenItem":"SyncFinances_hiddenItem__Be8Xa"};